const AI_SLIDES_GENERATOR_REFINE_RESULTS = 'AI Slides Generator > Refine results'
const AI_TEMPLATE_DESCRIPTION = 'Generate presentation description with AI'
const AI_GENERATE_QUIZ_FROM_DOC = 'Generate quiz from doc'
export {
  AI_SLIDES_GENERATOR_REFINE_RESULTS,
  AI_TEMPLATE_DESCRIPTION,
  AI_GENERATE_QUIZ_FROM_DOC,
}
